import script from "./BlogMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogMain.vue?vue&type=script&setup=true&lang=ts"

import "./BlogMain.vue?vue&type=style&index=0&id=7c0e1878&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0e1878"]])

export default __exports__